import React from 'react'

import { DOMAINS } from '../../../constants/selectLists/contriesList'

import { ReactComponent as PartnerBriteLogo } from '../../../assets/logos/partner-brite-logo-light.svg'
import { ReactComponent as CrowdCatchLogo } from '../../../assets/logos/crowd-catch-logo.svg'

const AppLogo = () => {
  const currentAppUrl = window.location.href

  if (currentAppUrl.includes(DOMAINS.crowdcatch)) {
    return <CrowdCatchLogo />
  } else {
    return <PartnerBriteLogo />
  }
}

export default AppLogo
